<div class="dialog-wrapper">
  <div class="dialog-header">
    <h2 class="dialog-title">{{ data?.title }}</h2>

    <button class="close-btn" type="button" (click)="close()" aria-label="Close">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="divider"></div>

  <h3 class="section-title">ABOUT THE HOTEL</h3>

  <div class="desc" [innerHTML]="descriptionHtml"></div>
</div>